﻿angular.module("services").factory("appService", function () {
	return {
		title: "MyApp",
		topBar: {
			visible: false
		},
	};
});
